import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { FiSave, FiTrash2 } from "react-icons/fi";
import PerfectScrollbar from "react-perfect-scrollbar";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import Footer from "../shared/Footer";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { useDropzone } from "react-dropzone";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SettingsUzantiEditForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [fileType, setFileType] = useState({ icon: "", type: "", extension: "" });
  const [newIcon, setNewIcon] = useState(null);

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue = "") => translations[key] || defaultValue;

  useEffect(() => {
    fetchFileType();
  }, [id]);

  const fetchFileType = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/fileType/${id}`);
      setFileType(response.data);
    } catch (error) {
      console.error("❌ Dosya türü alınamadı:", error);
      toast.error("Dosya türü alınamadı!");
    }
  };

  const handleDeleteIcon = async () => {
    if (!fileType.icon) return;

    try {
      await axios.delete(`${BASE_URL}/api/fileType/delete-icon/${fileType.icon}`);
      setFileType({ ...fileType, icon: "" });
      toast.success("İkon silindi.");
    } catch (error) {
      console.error("İkon silinemedi:", error);
      toast.error("İkon silinemedi.");
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/*": [] },
    maxFiles: 1,
    onDrop: async (acceptedFiles) => {
      const formData = new FormData();
      formData.append("icon", acceptedFiles[0]);

      try {
        const res = await axios.post(`${BASE_URL}/api/fileType/upload-icon`, formData);
        const fileName = res.data.fileName;
        setFileType((prev) => ({ ...prev, icon: fileName }));
        setNewIcon(fileName);
        toast.success("İkon yüklendi!");
      } catch (err) {
        console.error("❌ Yükleme hatası:", err);
        toast.error("İkon yüklenemedi!");
      }
    },
  });

  const handleSave = async () => {
    if (!fileType.icon || !fileType.type || !fileType.extension) {
      toast.warn("Tüm alanları doldurun!");
      return;
    }

    try {
      await axios.put(`${BASE_URL}/api/fileType/${id}`, fileType);
      toast.success("Dosya türü güncellendi!");
     
    } catch (error) {
      console.error("❌ Güncelleme hatası:", error);
      toast.error("Dosya türü güncellenemedi!");
    }
  };

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          <div className="card-body">
            <div className="card card-body general-info">
              <h5 className="fw-bold text-primary mb-4">
                {getText("LABEL_UPDATE_FILE_TYPE")}
              </h5>

              <div className="row g-3">
                {/* Dropzone */}
                <div className="col-md-4">
                  <label className="form-label fw-bold">{getText("TABLE_ICON_LABEL")}</label>
                  <div
                    {...getRootProps({
                      className: "dropzone",
                      style: {
                        border: "2px dashed #007bff",
                        padding: "15px",
                        textAlign: "center",
                        cursor: "pointer",
                        borderRadius: "8px",
                      },
                    })}
                  >
                    <input {...getInputProps()} />
                    {!fileType.icon ? (
                      <p>{getText("LABEL_IMAGE_DROPDOWN")}</p>
                    ) : (
                      <>
                        <img
                          src={`${BASE_URL}/cdn/fileType_icon/${fileType.icon}`}

                          alt="icon"
                          style={{ width: 60, height: 60, objectFit: "contain" }}
                        />
                       
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteIcon();
                          }}
                        >
                          <FiTrash2 /> 
                        </button>
                      </>
                    )}
                  </div>
                </div>

                {/* Type */}
                <div className="col-md-4">
                  <label className="form-label fw-bold">{getText("TABLE_TYPE_LABEL")}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={fileType.type}
                    onChange={(e) => setFileType({ ...fileType, type: e.target.value })}
                  />
                </div>

                {/* Extension */}
                <div className="col-md-4">
                  <label className="form-label fw-bold">{getText("TABLE_EXTENSION_LABEL")}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={fileType.extension}
                    onChange={(e) => setFileType({ ...fileType, extension: e.target.value })}
                  />
                </div>
              </div>

              {/* Save */}
              <div className="d-flex justify-content-center mt-4">
                <button className="btn btn-primary" onClick={handleSave}>
                  <FiSave className="me-2" /> {getText("SAVE_BTN")}
                </button>
              </div>
            </div>
          </div>
        </div>
        
      </PerfectScrollbar>
    </div>
  );
};

export default SettingsUzantiEditForm;
